module.exports = __webpack_public_path__ + "assets/img/34_727_big.953ad2c5.jpg";